<template>
    <div>
        <div class="container search">
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-6">
                            <h2>Automation Settings</h2>
                        </div>
                        <div class="col-md-6 text-right">
                            <a :href="$laravelRoute('manage')">Back To Admin Panel</a>
                        </div>
                    </div>
                    <form @submit.stop.prevent="onSubmit">
                        <messages :messages="messages"/>
                        <div class="row">
                            <div class="col-md-12 container-search">
                                <div class="form-row mt-2">
                                    <b-form-group class="col-md-3"
                                                  label="Auto stocklist email enabled"
                                                  label-for="enabled"
                                                  :state="fieldState('enabled')"
                                                  :invalid-feedback="invalidField('enabled')">
                                        <b-form-checkbox
                                            id="enabled"
                                            v-model="setting.enabled"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                </div>
                                <div class="form-row mt-2">
                                    <b-form-group class="col-md-6"
                                                  label="Scheduled stocklist time"
                                                  label-for="time"
                                                  label-class="label-time"
                                                  :state="fieldState('time')"
                                                  :invalid-feedback="invalidField('time')"
                                    >
                                        <el-time-select
                                            v-model="setting.value.time"
                                            :picker-options="{
                                                start: '08:00',
                                                step: '00:15',
                                                end: '23:45'
                                              }"
                                            placeholder="Select time">
                                        </el-time-select>
                                    </b-form-group>
                                </div>
                                <div class="form-row mt-2 day-wrapper">
                                    <b-form-group class=""
                                                  label="Monday"
                                                  label-for="monday"
                                                  :state="fieldState('monday')"
                                                  :invalid-feedback="invalidField('monday')">
                                        <b-form-checkbox
                                            id="monday"
                                            v-model="setting.value.monday"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group class=""
                                                  label="Tuesday"
                                                  label-for="tuesday"
                                                  :state="fieldState('tuesday')"
                                                  :invalid-feedback="invalidField('tuesday')">
                                        <b-form-checkbox
                                            id="tuesday"
                                            v-model="setting.value.tuesday"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group class=""
                                                  label="Wednesday"
                                                  label-for="wednesday"
                                                  :state="fieldState('wednesday')"
                                                  :invalid-feedback="invalidField('wednesday')">
                                        <b-form-checkbox
                                            id="wednesday"
                                            v-model="setting.value.wednesday"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group class=""
                                                  label="Thursday"
                                                  label-for="thursday"
                                                  :state="fieldState('thursday')"
                                                  :invalid-feedback="invalidField('thursday')">
                                        <b-form-checkbox
                                            id="thursday"
                                            v-model="setting.value.thursday"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group class=""
                                                  label="Friday"
                                                  label-for="friday"
                                                  :state="fieldState('friday')"
                                                  :invalid-feedback="invalidField('friday')">
                                        <b-form-checkbox
                                            id="friday"
                                            v-model="setting.value.friday"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group class=""
                                                  label="Saturday"
                                                  label-for="saturday"
                                                  :state="fieldState('saturday')"
                                                  :invalid-feedback="invalidField('saturday')">
                                        <b-form-checkbox
                                            id="saturday"
                                            v-model="setting.value.saturday"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group class=""
                                                  label="Sunday"
                                                  label-for="sunday"
                                                  :state="fieldState('sunday')"
                                                  :invalid-feedback="invalidField('sunday')">
                                        <b-form-checkbox
                                            id="sunday"
                                            v-model="setting.value.sunday"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                </div>
                                <hr>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 container-search">
                                <div class="form-row mt-2">
                                    <b-form-group class="col-md-3"
                                                  label="Auto move from unsold to stocklist enabled"
                                                  label-for="enable_auto_publish_unsold"
                                                  :state="fieldState('enable_auto_publish_unsold')"
                                                  :invalid-feedback="invalidField('enable_auto_publish_unsold')">
                                        <b-form-checkbox
                                            id="enable_auto_publish_unsold"
                                            v-model="setting.value.enable_auto_publish_unsold"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                </div>
                                <div class="form-row mt-2">
                                    <b-form-group class="col-md-6"
                                                  label="Scheduled publish unsold time"
                                                  label-for="unsold_time"
                                                  label-class="label-time"
                                                  :state="fieldState('unsold_time')"
                                                  :invalid-feedback="invalidField('unsold_time')"
                                    >
                                        <el-time-select
                                            v-model="setting.value.unsold_time"
                                            :picker-options="{
                                                start: '08:00',
                                                step: '00:15',
                                                end: '23:45'
                                              }"
                                            placeholder="Select time">
                                        </el-time-select>
                                    </b-form-group>
                                </div>
                                <div class="form-row mt-2 day-wrapper">
                                    <b-form-group class=""
                                                  label="Monday"
                                                  label-for="unsold_monday"
                                                  :state="fieldState('unsold_monday')"
                                                  :invalid-feedback="invalidField('unsold_monday')">
                                        <b-form-checkbox
                                            id="unsold_monday"
                                            v-model="setting.value.unsold_monday"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group class=""
                                                  label="Tuesday"
                                                  label-for="unsold_tuesday"
                                                  :state="fieldState('unsold_tuesday')"
                                                  :invalid-feedback="invalidField('unsold_tuesday')">
                                        <b-form-checkbox
                                            id="unsold_tuesday"
                                            v-model="setting.value.unsold_tuesday"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group class=""
                                                  label="Wednesday"
                                                  label-for="unsold_wednesday"
                                                  :state="fieldState('unsold_wednesday')"
                                                  :invalid-feedback="invalidField('unsold_wednesday')">
                                        <b-form-checkbox
                                            id="unsold_wednesday"
                                            v-model="setting.value.unsold_wednesday"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group class=""
                                                  label="Thursday"
                                                  label-for="unsold_thursday"
                                                  :state="fieldState('unsold_thursday')"
                                                  :invalid-feedback="invalidField('unsold_thursday')">
                                        <b-form-checkbox
                                            id="unsold_thursday"
                                            v-model="setting.value.unsold_thursday"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group class=""
                                                  label="Friday"
                                                  label-for="unsold_friday"
                                                  :state="fieldState('unsold_friday')"
                                                  :invalid-feedback="invalidField('unsold_friday')">
                                        <b-form-checkbox
                                            id="unsold_friday"
                                            v-model="setting.value.unsold_friday"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group class=""
                                                  label="Saturday"
                                                  label-for="unsold_saturday"
                                                  :state="fieldState('unsold_saturday')"
                                                  :invalid-feedback="invalidField('unsold_saturday')">
                                        <b-form-checkbox
                                            id="unsold_saturday"
                                            v-model="setting.value.unsold_saturday"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                    <b-form-group class=""
                                                  label="Sunday"
                                                  label-for="unsold_sunday"
                                                  :state="fieldState('unsold_sunday')"
                                                  :invalid-feedback="invalidField('unsold_sunday')">
                                        <b-form-checkbox
                                            id="unsold_sunday"
                                            v-model="setting.value.unsold_sunday"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                </div>
                                <div class="form-row mt-2">
                                    <div class="form-group col-md-6">
                                        <b-btn type="submit" class="btn">Save</b-btn>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BootstrapValidation from '../../mixins/bootstrap-validation';
import api from '../../api/api_resource'
import {getExceptionErrorMessage, getHttpValidationErrors} from "../../util/common";

export default {
    name: "AutoEmail",
    mixins: [BootstrapValidation],
    props: {
        heading: {
            type: String,
            default: 'Settings'
        },
    },
    data() {
        return {
            messages: [],
            setting: {
                name: 'auto_email',
                value: {
                    monday: true,
                    tuesday: true,
                    wednesday: true,
                    thursday: true,
                    friday: true,
                    saturday: false,
                    sunday: false,
                    time: '09:00',
                    enable_auto_publish_unsold: false,
                    unsold_monday: true,
                    unsold_tuesday: true,
                    unsold_wednesday: true,
                    unsold_thursday: true,
                    unsold_friday: true,
                    unsold_saturday: false,
                    unsold_sunday: false,
                    unsold_time: '15:00',
                },
                enabled: true,
            },
        }
    },

    async mounted() {
        await this.getSetting();
    },

    methods: {
        async getSetting(){
            let res = await this.axios.get(this.$laravelRoute('admin.site-settings.edit-auto-email'))
            if (res.data && res.data.setting) {
                this.setting = res.data.setting
            }
        },
        onSubmit() {
            this.messages = []
            this.errors = [];
            api.post('admin.site-settings.save', [], this.setting)
                .then(response => {
                    if (response && response.message) {
                        this.messages.push({type: 'success', message: response.message});
                    }
                }).catch(error => {
                let message = getExceptionErrorMessage(error);
                this.messages.push({type: 'danger', message});
                let errors = getHttpValidationErrors(error);
                if (errors) {
                    this.errors = errors;
                }

            });
        }
    }
}
</script>

<style scoped>
.day-wrapper {
    display: flex;
    justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/SiteSettings/AutoEmail.vue